import Component from '../abstracts/Component';
import hoverintent from 'hoverintent';
import 'bootstrap';
import {
  toggleTabIndex
} from "../utils/FocusableElementUtils";

export default class MenuComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-menu]',
      mainTarget: 'body',
      headerTop: '.header-top',
      header: '.main-header',
      benefitBar: '.js-benefit-bar',
      menuTitle: '[data-menu-title]',
      navigation: '.navigation',
      back: '[data-menu-back]',
      actions: '.header-actions',
      search: '.search-wrapper',
      mobileActions: '.js-mobile-actions',
      subMenu: '.js-submenu',
      navTabs: '.nav-tabs a'
    };
  }

  get CLASSES() {
    return {
      menuIn: 'menu-in',
      openClass: 'is-open',
      animate: 'animate',
      activeClass: 'is-active',
      subMenuClass: 'sub-menu-container',
      menuHeadingVisible: 'menu-heading-visible',
      logoHidden: 'logo-hidden',
      searchIsVisible: 'search-visible',
      visible: 'is-visible',
      showBackdrop: 'show-backdrop',
      backdropClass: 'visible'
    };
  }

  get DIMENSION() {
    return {
      top: () => {
        let header = document.querySelector(this.SELECTORS.header);
        let search = document.querySelector(this.SELECTORS.search);
        let sticky = header.classList.contains('is_stuck');
        return sticky ? header.clientHeight - search.clientHeight + 1 : header.clientHeight - search.clientHeight + this.DIMENSION.benefitBar() + 1;
      },
      benefitBar: () => {
        let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
        return this.$matchMedia(null, 'sm') ? benefitBar.clientHeight : 0;
      }
    }
  }

  constructor() {
    super();
    this.currentHover = null;
    this.preventClose = false;
    this.focusTrigger = null;
  }

  open(el) {
    return new Promise((resolve, reject) => {
      try {

        if (!el.classList.contains('has-sub-navigation')) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        } else {
          if (this.$matchMedia(null, 'sm')) {
            this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
              classes: 'dark'
            });
          }
        }

        const subMenuContainer = el.querySelector(`.${this.CLASSES.subMenuClass}`);
        el.classList.add(this.CLASSES.activeClass);

        if (subMenuContainer) {
          subMenuContainer.classList.add(this.CLASSES.openClass);
        }
        resolve(el)
      } catch (e) {
        reject(e)
      }
    });
  }

  close(el) {
    return new Promise((resolve, reject) => {
      try {

        if (this.preventClose) return;
        const subMenuContainer = el.querySelector(`.${this.CLASSES.subMenuClass}`);
        el.classList.remove(this.CLASSES.activeClass);
        if (subMenuContainer) {

          subMenuContainer.classList.remove(this.CLASSES.openClass);

          //reset tab menu
          const tabmenu = el.querySelectorAll('.nav-link');
          if (tabmenu) {
            $(tabmenu).tab('dispose');
            $(tabmenu[0]).tab('show')
          }
        }

        resolve(el)
      } catch (e) {
        reject(e)
      }
    });
  }

  setHeadingValue(str, link) {
    let headerTop = document.querySelector(this.SELECTORS.headerTop);
    headerTop.querySelector(this.SELECTORS.menuTitle).innerText = str;
    headerTop.querySelector(this.SELECTORS.menuTitle).setAttribute('href', link);
    headerTop.classList.add(this.CLASSES.menuHeadingVisible);
  }

  forceClose(hideBackdrop) {
    return new Promise((resolve, reject) => {
      try {
        const menuElement = document.querySelectorAll(this.SELECTORS.main);
        if (menuElement) {
          menuElement.forEach(el => {
            el.classList.remove(this.CLASSES.activeClass);
            let subMenu = el.querySelector(`.${this.CLASSES.subMenuClass}`);
            subMenu.classList.remove(this.CLASSES.openClass);
          });
        }
        if (hideBackdrop) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        }
        resolve();
      } catch (e) {
        reject()
      }
    });
  }

  bindHover() {

    let main = document.querySelectorAll(this.SELECTORS.main);
    let nav = document.querySelector(this.SELECTORS.navigation);
    let navList = document.querySelector(`${this.SELECTORS.navigation} .level-one`);

    //hoverintent for nav and backdrop
    hoverintent(navList, (e) => {
      if (e.target.parentElement.classList.contains('has-sub-navigation')) {
        if (this.$matchMedia(null, 'sm')) {
          // nav.classList.add('active');
          this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
            classes: 'dark'
          });
        }
      }
    }, (e) => {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    }).options({
      interval: 100,
      timeout: 100
    });

    //hoverintent for each item of nav
    main.forEach(el => {
      hoverintent(el,
        (e) => {
          if (this.$matchMedia(null, 'lg') && e.target.parentElement.hasAttribute('data-menu')) {
            this.forceClose().then(res => {
              this.currentHover = e.target.parentElement;
              this.open(e.target.parentElement).then(res => this.preventClose = false);
            });
          }
        },
        (e) => {
          if (this.$matchMedia(null, 'lg')) {
            this.close(this.currentHover);
          }
        }).options({
        interval: 100,
        timeout: 100
      });
    });

    this.$on('mouseenter.subMenu', () => {
      this.preventClose = true;
    }, this.SELECTORS.subMenu);

    this.$on('mouseleave.subMenu', () => {
      this.preventClose = false;
    }, this.SELECTORS.subMenu);

  }

  bindEscape() {
    this.$on(`${this.$customEvents.KEYBOARD_EVENTS.escape}.menu`, () => {
      this.forceClose(true).then(res => {
        this.focusTrigger.nextSibling.focus();
      });
    });
  }

  showSearch() {
    let header = document.querySelector(this.SELECTORS.header);

    this.$on(this.$customEvents.SEARCH_EVENTS.visible, () => {
      header.classList.add(this.CLASSES.searchIsVisible);
    });

    this.$on(this.$customEvents.SEARCH_EVENTS.hidden, () => {
      header.classList.remove(this.CLASSES.searchIsVisible)
    });
  }

  bindClick() {

    this.$on('click.menu', ({
      event
    }) => {
      if (!event.target.classList.contains('js-first-level-link')) return true;
      if (!this.$matchMedia('lg')) return true;
      event.preventDefault();
      [...event.currentTarget.parentElement.children].map(sibling => {
        return sibling.classList.remove(this.CLASSES.activeClass)
      });
      event.currentTarget.classList.toggle(this.CLASSES.activeClass);

      let link = event.currentTarget.querySelector('a.link');

    }, `${this.SELECTORS.main}.has-sub-navigation`);

    this.$on(this.$customEvents.QUICK_CATEGORIES_EVENTS.show, ({
      payload
    }) => {
      this.timeout = null;
      this.quickCategoryShow(payload.id).then(el => {
        this.$emit(this.$customEvents.QUICK_CATEGORIES_EVENTS.visible);
      });
    });

  }

  quickCategoryShow(id) {
    return new Promise((resolve, reject) => {
      try {
        const target = document.querySelector(`#${id}`);
        target.classList.add(this.CLASSES.activeClass);
        resolve(target);
      } catch (e) {
        reject(e)
      }
    });
  }

  bindBack() {
    this.$on('click.menu', () => {
      let menuTriggers = document.querySelectorAll(this.SELECTORS.main);
      document.querySelector(this.SELECTORS.headerTop).classList.remove(this.CLASSES.menuHeadingVisible);
      menuTriggers.forEach(trigger => {
        const tabmenu = trigger.querySelectorAll('.nav-link');
        if (tabmenu) {
          $('tabmenu.active').tab('dispose');
          $(tabmenu[0]).tab('show')

        }
        return trigger.classList.remove(this.CLASSES.activeClass)
      });


    }, this.SELECTORS.back)
  }

  toggleMobileActions(show) {
    const actions = document.querySelector(this.SELECTORS.mobileActions);
    let timeout = null;
    if (show) {
      timeout = setTimeout(() => {
        actions.classList.add(this.CLASSES.visible)
      }, 200);
    } else {
      clearTimeout(timeout);
      actions.classList.remove(this.CLASSES.visible)
    }
  }

  bindBurgerClick() {
    this.$on(this.$customEvents.BURGER_EVENTS.click, ({
      payload
    }) => {
      let headerTop = document.querySelector(this.SELECTORS.headerTop);

      if (payload.menuIn) {
        document.body.classList.add(this.CLASSES.menuIn);
        document.documentElement.classList.add(this.CLASSES.menuIn);
        headerTop.classList.add(this.CLASSES.menuIn);

        if (this.$matchMedia(null, 'sm')) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
            classes: 'dark'
          });
        }
      } else {
        let dataMenu = document.querySelector(`${this.SELECTORS.main}.${this.CLASSES.activeClass}`);
        if (dataMenu) dataMenu.classList.remove(this.CLASSES.activeClass);
        document.body.classList.remove(this.CLASSES.menuIn);
        document.documentElement.classList.remove(this.CLASSES.menuIn);
        headerTop.classList.remove(this.CLASSES.menuIn, this.CLASSES.menuHeadingVisible);

        if (this.$matchMedia(null, 'sm')) {
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        }

      }

      this.toggleMobileActions(payload.menuIn);

    });
  }

  bindKeyboardNavigation() {

    this.$on('keydown.menu', ({
      event
    }) => {
      const currentEntry = event.currentTarget.parentElement;
      if (event.which == 13 || event.keyCode == 13) {
        event.preventDefault();
        if (currentEntry.classList.contains('is-active')) {
          this.close(currentEntry);
          this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        } else {
          this.forceClose().then(res => {
            this.open(currentEntry).then(res => {
              this.focusTrigger = res;
            });
          });
        }
      }
    }, `${this.SELECTORS.main} > a`);

    this.$on('focus.submenu', ({
      event
    }) => {
      let subMenu = event.target.parentElement.parentElement.parentElement.querySelectorAll('.tab-content > .sub-menu-component');
      subMenu.forEach((element) => {
        if (element.classList.contains('active')) {
          toggleTabIndex(element, true);
        } else {
          toggleTabIndex(element, false);
        }
      });
    }, `${this.SELECTORS.subMenu} ${this.SELECTORS.navTabs}`);

    this.bindEscape();
  }

  bindMobileEvents() {
    this.bindClick();
    this.bindBack();
    this.bindBurgerClick();
  }

  render() {
    if (document.querySelector(this.SELECTORS.header) === null) return;
    this.bindMobileEvents();
    this.bindHover();
    this.showSearch();
    this.bindKeyboardNavigation();
  }
}
